<template>
    <div>
        <div class="dfjc">
            <div :class="baseerp+'color'" v-if="id!=0">{{formData.i_req_state==6?'[已完结]':'['+formData.stateTxt+']'}}</div>
            <el-button type="primary" @click="publish" v-if="id!==0&&formData.i_state==1&&formData.i_req_state!=6" :disabled="disable" :class="baseerp+'btn'" size="small" >发布中标结果</el-button>
        </div>
        <el-table
                class="mrt10"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="formData.offers"
                :header-cell-style="{background:'#fbfcfd',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%">
            <el-table-column :label="$t('form_serial_number')" align="center"  width="50" type="index" >
            </el-table-column>
            <el-table-column  align="center" label="品种大类"  width="80"  prop="pzPName" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" :label="$t('form_product_name')" width="100" prop="pzName" show-overflow-tooltip>
            </el-table-column>
            <el-table-column  align="center" label="规格" width="80" prop="specification" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"  label="报价人" width="80" prop="vc_lruname" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"  label="报价公司" width="80" prop="vc_khname" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="报价(元)" width="80"  prop="f_price" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="投标数量" width="80" prop="f_offernum" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="中标数量" width="80"  prop="f_successnum" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="需求数量" width="80" prop="num" show-overflow-tooltip></el-table-column>
            <el-table-column align="center"  label="说明"  prop="vc_note">
                <template slot-scope="scope" >
                    <el-input v-model="scope.row.vc_note" style="width: 100%" v-if=" id==0" clearable size="mini" ></el-input>
                    <span v-if=" id==0&&scope.row.showNote=='show'" style="font-size: 12px;color: red;display: block">中标总量与需求量不一致,请填写说明</span>
                    <span v-if=" id!==0">{{scope.row.vc_note}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="中标状态" width="80"  v-if=" id!==0" prop="typeTxt" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center" v-if=" id==0">
                <template slot-scope="scope" v-if="scope.row.noselect">
                    <el-checkbox v-model="scope.row.i_type">流标</el-checkbox>
                </template>
            </el-table-column>
        </el-table>
        <div class="dfjc">
            <div>
                <span style="display: inline-block;width: 75px">制单人:</span>
                <span>{{formData.vc_lruname}}</span>
            </div>
            <div>
                <span style="display: inline-block;width: 75px">制单日期:</span>
                <span>{{formData.dt_createtime}}</span>
            </div>
        </div>
        <div class="center">
            <el-button type="warning" @click="flowSub" :disabled="disable"v-if=" id!==0&&formData.i_state==0" size="small" >提交审批</el-button>
            <el-button type="danger" @click="fail" :disabled="disable" v-if="id!==0&&formData.i_state==0"size="small">{{$t('button_nullify')}}</el-button>
            <el-button type="primary" @click="confirmOffer" v-if="id==0" :disabled="disable" :class="baseerp+'btn'" size="small" >{{$t('button_confirm')}}</el-button>
            <el-button @click="goback" :disabled="disable" size="small" >取消</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "../../api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "OfferList",
        props:{
            confirmData:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                baseerp:'',
                formData:{
                    offers: [],
                },
                tableHeight:0,
                disable:false,
                id:0,
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            confirmData: {
                handler() {
                    this.id=this.confirmData.id;

                    if(this.id==0){
                        this.formData=this.confirmData
                        this.formData.vc_lruname=sessionStorage.getItem("lruname")
                        // this.i_res_id=this.confirmData.id;
                        this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS()
                        // console.log('this.formData',this.formData)
                    }else{
                        this.i_res_id=this.confirmData.i_res_id;
                        this.resultDetail()
                    }
                },
                immediate:true,
                deep:true
            }
        },
        mounted() {

            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();


            })
        },
        activated(){
            this.onResize();
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h*0.5;
                if(this.tableHeight<60)this.tableHeight=60
            },
            goback(){
                this.$emit('close',this.back)
            },
            async resultDetail(){
                let param={
                    i_id:this.i_res_id
                };
                let res=await API.resultDetail(param);
                if ( res.code == 1 ){
                    this.formData=res.data;
                    this.id=this.formData.i_id
                    this.i_res_id=this.formData.i_id
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            publish(){
                this.$confirm('是否发布中标结果','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.publishResult()
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
             async publishResult(){
                let param={
                    i_id:this.i_res_id
                };
                let res=await API.publishResult(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('bidsList','close')
                    this.goback()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            fail(){
                this.$confirm('是否作废该中标','提示',{
                    confirmButtonText:'继续',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(async()=>{
                    this.cancelResult()
                }).catch(()=>{
                    this.$message({
                        type:'info',
                        message:'已取消'
                    })
                })
            },
            async cancelResult(){
                this.disable=true

                let param={
                    i_id:this.i_res_id
                };
                let res=await API.cancelResult(param);
                if ( res.code == 1 ){
                    this.formData=res.data;
                    this.id=this.formData.i_id
                    this.disable=false
                    this.$emit('bidsList','close')
                    this.goback()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.disable=false
                    this.$message.error(res.message);
                }else{
                    this.disable=false
                    this.$message.error(res.message);
                }
            },
            handeltable(){
                let arr=JSON.parse(JSON.stringify(this.formData.offers)),newArr=[];

                for (let sg of arr) {
                    let pz = newArr.findIndex(pz => pz.pzId == sg.i_pzid&&sg.i_type!=-1)
                    // console.log(pz,'pz')
                    if (pz!== -1) {
                        newArr[pz].applys.push(sg)
                    } else {
                        let obj ={
                            pzId:sg.pzId,
                            num:sg.num,
                            pzName:sg.pzName,
                            specification:sg.specification,
                            i_req_subid:sg.i_req_subid,
                            // f_addnum:sg.f_addnum,
                            unit:sg.unit,
                            applys:[sg],
                        };
                        newArr.push(obj)
                    }
                }
                for (let info of newArr) {
                    let sum=0;
                    info.applys.forEach(a=>{sum+=a.f_successnum});
                    info.sum=sum;
                    if(info.sum!=info.num){
                       let i= this.formData.offers.findIndex(o=>o.pzId==info.pzId)
                        if(i!=-1)this.formData.offers[i].showNote='show'
                        this.$forceUpdate()
                    }
                }
                // console.log(newArr,'newwwwwww',this.formData.offers)

            },
            async confirmOffer(){

                let formData=JSON.parse(JSON.stringify(this.formData));
                for (let i =0;i<formData.offers.length;i++){
                    if(formData.offers[i].i_type===null||formData.offers[i].i_type===false){
                        this.$message.error('有品种没有选择报价,请勾选流标或重新选择报价');
                        return
                    }else if(formData.offers[i].i_type===true){
                        formData.offers[i].i_type=-1
                    }
                }
                this.handeltable();
                // return
                this.disable=true
                let param=formData;
                let res=await API.confirmOffer(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.id=res.data;
                    this.i_res_id=res.data;
                    this.resultDetail();
                    this.$emit('bidsList','save',this.i_res_id);
                    this.disable=false
                }else if (res.code == -2) {
                    this.disable=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disable=false

                }

            },
            async flowSub(item){
                this.disable=true;
                this.$message.success('正在提交，请稍候')
                let param={
                    id:this.formData.i_id,
                    i_id:this.formData.i_id,
                    dt_createtime:this.formData.dt_createtime,
                    i_lruid:this.formData.i_lruid,
                    table:this.formData.table,
                    busType:this.formData.busType,
                    validateCode:this.formData.validateCode,
                    validateKeynames:this.formData.validateKeynames,
                };
                let res=await API.flowSub(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.$emit('bidsList','close')
                    this.goback()
                    this.disable=false
                }else if (res.code == -2) {
                    this.disable=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disable=false;
                    this.$message.error(res.message);
                }
            },
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`;
            },

        },
    }
</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 10px;
        margin-bottom: 10px;

    }
    .mrl10{
        margin-left: 10px;
    }
    .mrA{
        margin-top: auto;
        margin-bottom: auto;
    }
    .dfjc{
        display: flex;
        justify-content: space-between
    }
    .center{
        text-align: center;
    }
/deep/{
    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .el-dialog{
        min-width: 420px;
    }
    .el-input-number--mini{
        width: 80px;
    }
    .el-input-number.is-without-controls .el-input__inner{
        padding-left: 0px;
        padding-right: 0px;
    }
    .el-table__expand-icon{
        display: none;
    }
    .el-table__expanded-cell[class*=cell]{
        padding: 5px;
    }
}
</style>